export default "__VITE_ASSET__vpRPcAv1__"